var React = require('react');

function Time (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"10.5","cy":"10","r":"9.25","stroke":"#001D3B","strokeWidth":"1.5","key":0}),React.createElement("path",{"d":"M10.5 12C9.94772 12 9.5 11.5523 9.5 11L9.5 5C9.5 4.44772 9.94771 4 10.5 4C11.0523 4 11.5 4.44772 11.5 5L11.5 11C11.5 11.5523 11.0523 12 10.5 12Z","fill":"#001D3B","key":1}),React.createElement("path",{"d":"M9.5 11C9.5 10.4477 9.94772 10 10.5 10H13.5C14.0523 10 14.5 10.4477 14.5 11C14.5 11.5523 14.0523 12 13.5 12H10.5C9.94772 12 9.5 11.5523 9.5 11Z","fill":"#001D3B","key":2})]);
}

Time.defaultProps = {"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none"};

module.exports = Time;

Time.default = Time;
